<!--
  @author xiehan
  @description 数据查询 查询历史页
  @date 2018/11/26
-->
<template>
  <div class="checkHistory__content">
    <g-back :history="history"></g-back>
    <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
      <el-form-item :label="$t('dataSearch.operateUser')" prop="userName">
        <el-input v-model="searchForm.userName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('dataSearch.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button 
          type="primary" 
          v-text="$t('common.search')"
          @click="search(true)"
          v-g-rac="gRac('checkHistory@search')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tableData"
      :head="tableHead"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="$t('dataSearch.dataSearchDetail')"
      :visible.sync="dialogDetailShow"
      width="600px">
      <el-form label-width="80px" input-width="170px" :inline="true">
        <el-form-item :label="$t('dataSearch.table.userName')">
          <span v-text="detailForm.userName"></span>
        </el-form-item>
        <el-form-item :label="$t('dataSearch.table.databaseType')">
          <span v-text="detailForm.databaseType"></span>
        </el-form-item>
        <el-form-item :label="$t('dataSearch.table.database')">
          <span v-text="detailForm.database"></span>
        </el-form-item>
        <el-form-item :label="$t('dataSearch.table.dataTable')">
          <span v-text="detailForm.dataTable"></span>
        </el-form-item>
        <el-form-item :label="$t('dataSearch.table.time')">
          <span v-text="detailForm.time"></span>
        </el-form-item>
        <el-form-item :label="$t('dataSearch.table.condition')" input-width="400px">
          <span v-text="detailForm.condition"></span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailShow = false" v-text="$t('common.close')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dataSearchBiz from '@/logic/logRetrieve/dataSearchBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac],
    data () {
      return {
        history: [],
        searchForm: {
          userName: '',
          startTime: '',
          endTime: ''
        },
        currentPage: 1,
        perPageCount: 10,
        tableData: {},
        tableHead: [],
        tableControl: [{
          rac: () => this.gRac('checkHistory@detail'),
          label: this.$t('common.check'),
          callback: (row, index, data) => {
            this.detailForm = row
            this.dialogDetailShow = true
          }
        }],
        dialogDetailShow: false,
        detailForm: {}
      }
    },
    components: {},
    methods: {
      setHistory () {
        this.history = []
        this.history.push({ name: this.$t('dataSearch.dataSearchHistory') })
      },
      search (fromClick = false) {
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        this.initTable()
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        for (let i in this.searchForm) {
          if (this.searchForm[i]) searchObj[i] = this.searchForm[i]
        }
        dataSearchBiz.getHisRecord(searchObj).then((data) => {
          data.dataList.map(item => {
            item.condition = JSON.stringify(item.condition)
            item.time = TimeFormat.getFormatTime(item.time)
          })
          this.tableData = data
        })
      },
      initTable () {
        this.tableHead = [
          { key: 'userName', label: this.$t('dataSearch.table.userName') },
          { key: 'databaseType', label: this.$t('dataSearch.table.databaseType') },
          { key: 'database', label: this.$t('dataSearch.table.database') },
          { key: 'dataTable', label: this.$t('dataSearch.table.dataTable') },
          { key: 'condition', label: this.$t('dataSearch.table.condition') },
          { key: 'time', label: this.$t('dataSearch.table.time') }
        ]
      },
      currentChange (val) {
        this.currentPage = val
        this.search()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.search()
      }
    },
    watch: {
      $route (to, from) {
        if (from.name === 'dataSearch' && to.name === 'dataSearchHistory') this.search()
      }
    },
    mounted () {
      this.setHistory()
      this.search()
    }
  }
</script>

<style scoped>
</style>